import React from "react";

const SortDownIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="sort_down_icon"
      data-name="sort down"
      {...props}
      width={props.width || "21"}
      height={props.height || "20"}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.16729 3.33337H15.1673V5.00004H5.16729V3.33337ZM10.1673 17.0117L15.7565 11.4225L14.5781 10.2442L11.0006 13.8217V6.66671H9.33396V13.8217L5.75646 10.2442L4.57812 11.4225L10.1673 17.0117Z"
        fill={props.fill || "#6B7A94"}
      />
    </svg>
  );
};

export default SortDownIcon;
